import React from "react";

const ButtonAdd = ({ onClick }) => {
  return (
    <button className="round-button shadow secondary" onClick={onClick}>
      <i className="fas fa-plus"></i>
    </button>
  );
};

export default ButtonAdd;
